<section class="form_section">
    <div class="dialog-header">
      <button mat-icon-button (click)="cerrarDialogo()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <h2>Actualizar Descripción</h2>
    <form action="" [formGroup]="formNuevaDescripcion" (ngSubmit)="submit()" class="form_register_minutes">
        <mat-form-field>
            <mat-label>Nueva Descripción</mat-label>
            <textarea matInput formControlName="description" placeholder="Describe al cliente y operación a evaluar"> </textarea>
        </mat-form-field>

        <button mat-stroked-button  color="primary" class="w-50" [disabled]="!formNuevaDescripcion.valid">
            Guardar
        </button>
    </form>
</section>
  